import axios from "axios";
import { store } from "../stores/store";
import { showNotification } from "../slices/AlertMessageSlice";
import { getToken } from "@/token/token";
import getHeaders from "@/domain/DomainHeader";

// const headers = await getHeaders(window.location.hostname);

// console.log("headers", window.location.hostname, headers);

let API = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  // headers: {
  //   "Content-Type": "application/json",
  //   "X-Tenant-Id": "superadmin",
  // },
  // headers: headers,
});

API.interceptors.request.use(
  async (config) => {
    // ✅ Tenant / domain headers
    if (typeof window !== "undefined") {

      const headers = await getHeaders(window.location.hostname);
      config.headers = {
        ...config.headers,
        ...headers,
      };

      console.log("headers", window.location.hostname, headers);

    }

    const token = getToken("token") || null;
    // typeof window !== "undefined" ? localStorage.getItem("token") : null;

    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

API.interceptors.response.use(
  (response) => {
    if (typeof window !== "undefined") {
      console.log("API response config", response);
      if (
        response.data.success &&
        (response.config.method === "post" ||
          response.config.method === "put" ||
          response.config.method === "delete")
      ) {
        store.dispatch(
          showNotification({
            messageToaster: true,
            toasterType: "success",
            toasterMessage: response?.data?.message || "Success!",
          }),
        );

        // if(response?.config?.url === "/auth/refresh-token") {
        //   store.dispatch(showNotification({ messageToaster: false, toasterType: "success", toasterMessage: response?.data?.message || "Success!"}));

        // }
        // else if(response?.config?.url === "/api/user-activity") {
        //   store.dispatch(showNotification({ messageToaster: false, toasterType: "success", toasterMessage: response?.data?.message || "Success!"}));

        // }
        // else if(response?.config?.url.includes("read")) {
        //   store.dispatch(showNotification({ messageToaster: false, toasterType: "success", toasterMessage: response?.data?.message || "Success!"}));

        // }
        // else {
        //   store.dispatch(showNotification({ messageToaster: true, toasterType: "success", toasterMessage: response?.data?.message || "Success!"}));

        // }
      }
    }

    return response;
  },

  function (error) {
    if (typeof window !== "undefined") {
      console.log("API error config", error);
      if (
        !error?.response?.data?.success &&
        // window.location.pathname.split("/").indexOf("auth") === -1 &&
        (error.config.method === "post" ||
          error.config.method === "put" ||
          error.config.method === "delete")
      ) {
        store.dispatch(
          showNotification({
            messageToaster: true,
            toasterType: "error",
            toasterMessage:
              error?.response?.data?.message ||
              error?.response?.data?.error ||
              "Something went wrong! Please check your internet connecton.",
          }),
        );
        // if(error?.config?.url === "/auth/refresh-token") {
        //   store.dispatch(showNotification({ messageToaster: false, toasterType: "error", toasterMessage: error?.response?.data?.message || "Something went wrong! Please check your internet connecton."}));

        // }
        // else if(error?.config?.url === "/api/user-activity") {
        //   store.dispatch(showNotification({ messageToaster: false, toasterType: "error", toasterMessage: error?.response?.data?.message || "Something went wrong! Please check your internet connecton."}));

        // }
        // else if(error?.config?.url.includes("read")) {
        //   store.dispatch(showNotification({ messageToaster: false, toasterType: "error", toasterMessage: error?.response?.data?.message || "Something went wrong! Please check your internet connecton."}));

        // }
        // else {
        //   store.dispatch(showNotification({ messageToaster: true, toasterType: "error", toasterMessage: error?.response?.data?.message || "Something went wrong! Please check your internet connecton."}));

        // }
      } else if (error?.response?.data?.error === "Unauthorized") {
        store.dispatch(
          showNotification({
            messageToaster: true,
            toasterType: "error",
            toasterMessage: "Your session is expired! Please relogin",
          }),
        );
        // if(typeof window !== undefined) window.location.href = '/user/login';
      }
    }

    return Promise.reject(error);
  },
);

export default API;
